import request from "../Utils/request";

export function postData(url: string, data?: any) {
  return request.post(url, data);
}
